import {
  appBgColor,
  boxShadow, min, primaryColor, primaryFont,
  secondaryFont, wMBold, wLight,
  wMedium, primaryHeadingColor, wELight, minWidthApp, maxTablet, maxMobile,
  backDropPersonality, wbSmartLayer, wBold,
  joinSession, scrollbar, maxWidth1300,
  textTruncateSnippet, retina, retinaOne,
  scrollbarTransparent, smMobile, midMobile,
  primaryBgColor, backgroundGreenLayer,
  SecondaryColor, midTablet, white,
  minExtraLargeScreen, minStandardScreen,
  greyColor,
  wMLight,
  minTablet,
  midWidthApp,
  maxWidth1170,
  maxWidth,
} from '../../Utils/utilsStyle';

const generalStyleHighlights = `
  .highlights-modal {
    width: 1169px !important;
    .ant-modal-content {
      border-radius: 16px;
      overflow: hidden;
      .ant-modal-close {
      }
    }
    .ant-modal-header {
      border-bottom: 1px solid #E8ECED;
      padding: 20px 24px;
      margin-bottom: 0px;
      border-bottom: 0px !important;
      .ant-modal-title {
        font-size: 28px;
        font-weight: ${wMBold};
        color: ${primaryHeadingColor};
        @media all and (max-width: ${maxMobile}) {
          font-size: 18px;
        }
        .modal-title-wrapper {
          .modal-title {
            margin-left: 8px;
          }
          .gilroy-small-icon {
            width: 33px;
            height: 29px;
            margin-left: -4px;
            @media all and (max-width: ${maxMobile}) {
              width: 28px;
              height: 24px;
            }
          }
          .modal-tooltip-content-wrapper {
            color: #000;
            font-family: ${primaryFont};
            font-size: 14px;
            font-weight: ${wLight};
            line-height: 16px;
            p {
              margin-bottom: 0;
              color: #000;
              font-family: ${primaryFont};
              font-size: 14px;
              font-weight: ${wLight};
              line-height: 16px;
            }
          }
        }
      }
    }
    .ant-modal-body {
      max-height: 50vh;
      overflow-y: auto;
      @media all and (min-width: 1900px) {
        max-height: 60vh;
      }
    }
    .ant-modal-footer {
      display: flex;
      justify-content: end;
    }
    button {
      cursor: pointer;
      height: 31px;
    }
    // Info Card Styles
    .info-card {
      .textbox {
        background: #F9F8F6;
        border-radius: 10px;
        padding: 16px 35px 16px 16px;
        margin-bottom: 20px;
        p {
          color: #667982;
          font-family: ${primaryFont};
          font-size: 16px;
          font-weight: ${wMedium};
          letter-spacing: -0.15px;
          margin: 0;
          @media all and (max-width: ${maxMobile}) {
            font-size: 14px;
          }
        }
      }
    }
    // Bullet List Styles
    .bullet-list-section {
      margin-bottom: 24px;
      .bullet-list {
        margin: 0;
        padding-left: 20px;
        
        li {
          color: #667982;
          font-family: ${primaryFont};
          font-size: 16px;
          font-weight: ${wMedium};
          letter-spacing: -0.15px;
          margin-bottom: 8px;
          @media all and (max-width: ${maxMobile}) {
            font-size: 14px;
          }
        }
      }
    }

    .ordered-list-section {
      margin-bottom: 24px;
      .ordered-list {
        background: #F9FAFB;
        padding: 15px 35px 15px 35px;
        border-radius: 10px;
        margin: 0;

        li {
          color: #667982;
          font-family: ${primaryFont};
          font-size: 16px;
          font-weight: ${wMedium};
          letter-spacing: -0.15px;
          margin-bottom: 8px;
          @media all and (max-width: ${maxMobile}) {
            font-size: 14px;
          }
        }
      }
    }

    // Copyable TextArea Styles
    .copyable-textarea {
      position: relative;
      background: #F9F8F6;
      border-radius: 10px;
      padding: 16px;
      
      .copy-icon {
        position: absolute;
        top: 12px;
        right: 12px;
        cursor: pointer;
        color: #667982;
        font-size: 18px;
        transition: color 0.2s;
        z-index: 1;

        &:hover {
          color: #1A2A36;
        }
        
        .copy-tooltip {
          position: absolute;
          top: -30px;
          right: 0;
          background: #1A2A36;
          color: white;
          padding: 4px 8px;
          border-radius: 4px;
          font-size: 12px;
          white-space: nowrap;
        }
      }
      
      .text-content {
        position: relative;
        min-height: 95px;
        
        pre {
          font-family: ${primaryFont};
          font-weight: ${wMedium};
          font-size: 16px;
          color: #000;
          margin: 0;
          white-space: pre-wrap;
          word-wrap: break-word;
          background: transparent;
          border: none;
          padding-right: 30px;
          @media all and (max-width: ${maxMobile}) {
            font-size: 14px;
          }
        }
        .empty-placeholder {
          color: #888888;
          font-style: italic;
          font-weight: ${wLight};

        } 
        .pre2 {
          font-family: ${primaryFont};
          font-weight: ${wMedium};
          font-size: 16px;
          color: #667982;
          margin: 0;
          white-space: pre-wrap;
          word-wrap: break-word;
          background: transparent;
          border: none;
          padding-right: 30px;
          @media all and (max-width: ${maxMobile}) {
            font-size: 14px;
          }
        }

        .edit-icon {
          position: absolute;
          bottom: 0px;
          right: 0px;
          cursor: pointer;
          color: #667982;
          font-size: 16px;
          transition: color 0.2s;
          
          &:hover {
            color: #1A2A36;
          }
        }
      }
      
      .edit-mode {
        .editable-textarea {
          width: 100%;
          padding: 12px 40px 12px 12px;
          border: 1px solid ${primaryColor};
          border-radius: 10px;
          font-family: ${primaryFont};
          font-weight: ${wMedium};
          font-size: 16px;
          color: #000;
          // resize: vertical;
          @media all and (max-width: ${maxMobile}) {
            font-size: 14px;
          }
          
          &:focus {
            outline: none;
            border-color: ${primaryColor};
          }
        }
        
        .edit-actions {
          position: absolute;
          right: 30px;
          bottom: 30px;
          display: flex;
          align-items: center;
          gap: 10px;
          .action-icon {
            cursor: pointer;
              svg {
                width: auto;
                height: 13px;
              }
          }
          .close-icon {
            cursor: pointer;
            svg {
              width: auto;
              height: 13px;
            }
          }
        }
      }
    }
    // Gilroy Section Styles
    .gilroy-section {
      .prompt-section {
        margin-bottom: 32px;
      }
      
      .insights-section {
        margin-bottom: 32px;
        
        .insights-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 16px;
          
          .insight-item {
            background: #F9F8F6;
            padding: 12px 16px;
            border-radius: 8px;
            
            .insight-label {
              font-weight: ${wMLight};
              color: #1A2A36;
              font-size: 14px;
              margin-right: 8px;
            }
            
            .insight-value {
              color: #667982;
              font-size: 14px;
            }
          }
        }
      }
      
      .actions-section {
        margin-bottom: 24px;
        
        .actions-list {
          margin: 0;
          padding-left: 20px;
          
          li {
            color: #667982;
            font-family: Roboto;
            font-size: 14px;
            margin-bottom: 8px;
            line-height: 1.5;
          }
        }
      }
    }
  }
  // Common styling
  :is(.sections-title, .section-subtitle, .highlight-modal-section-title) {
    color: ${primaryHeadingColor};
    font-family: ${primaryFont};
    font-size: 18px;
    font-weight: ${wMedium};
    margin-bottom: 8px;
    @media all and (max-width: ${maxMobile}) {
      font-size: 16px;
    }
  }

  .list-perf-item {
    content-visibility: auto;
    contain-intrinsic-size: auto 280px;
  }

`;

export default generalStyleHighlights;
